export const lsFilterkeyStr = "open_costing_filter_obj";

export const generateCostingDetailsExcel = () => {};
